type Roll = Record<string, unknown>;
const upper = (value: unknown): string => String(value ?? '').trim().toUpperCase();
const castItems = new Set(['spell', 'curse', 'menta', 'sanguine', 'ability', 'quick_ability', 'free_ability',
    'full_ability', 'reaction_ability']);

/** The applying action marks its caster before commit. Damage type, item identity and a fresh roll id
 * alone never establish another cast: status ticks and delayed triggers have all three too. */
export function castCommitId(roll: Roll): string | null {
    const source = upper(roll.roll_cast_source_id);
    return source && source === upper(roll.roll_by) && !roll.triggered_effect_item_id
        ? String(roll.roll_id ?? '').trim() || null : null;
}

export function isCastItemRoll(roll: Roll): boolean {
    return castItems.has(String(roll.roll_item_id_item_type ?? '').toLowerCase());
}

export function isCastEffectRow(roll: Roll): boolean {
    const attack = ['attack_ability', 'opportunity_attack_ability'].includes(String(roll.roll_item_id_item_type ?? '').toLowerCase());
    return !attack && (isCastItemRoll(roll) || !!roll.roll_vfx_recipe) && !castCommitId(roll);
}
